import type { EventRepository } from '@zetyar/data-contracts'
import { createSupabaseEventRepository } from '@zetyar/supabase-client'
import { getSupabaseClient } from '@/infrastructure/supabase/app'

export const webEventRepository: EventRepository = createSupabaseEventRepository(getSupabaseClient())
